var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.145,
    height: 20.513,
    viewBox: "0 0 13.145 20.513",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Campfire_logo",
    "data-name": "Campfire logo",
    d: "M782.124,285.133s-4.636-2.241-2.7-8.212a12.721,12.721,0,0,1,2.132-3.527c1.751-2.261,2.239-6.451,2.239-7.671a.275.275,0,0,1,.412,0,6.1,6.1,0,0,1,2,2.832,8.823,8.823,0,0,1,.534,2.709c.021,1.4.185,3.633.821,3.633s.718-.965.718-2.216c0,0,.144-.369.513.041a10.157,10.157,0,0,1,2.149,7.944s-.285,3.47-3.223,4.467c0,0-.4-.044-.145-.537s.749-.923.391-3.1a7.035,7.035,0,0,0-1.432-2.9,19.583,19.583,0,0,1-1.824-3.971s-2.165,4.381-2.727,5.744-.426,3.6.426,4.4C782.4,284.764,782.6,285.133,782.124,285.133Z",
    transform: "translate(-778.438 -265.129)",
    fill: "none",
    stroke: "#639540",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampLogo);
export default __webpack_public_path__ + "static/media/camp_logo.5bd573bc4ac44040e173f4c323ae193b.svg";
export { ForwardRef as ReactComponent };